<template>
  <v-list-item density="compact" :width="300" :ripple="false">
    <v-list-item-title>{{ activeDownload.fileName }}</v-list-item-title>
    <v-list-item-subtitle>
      <v-progress-linear
        v-if="!activeDownload.error"
        :model-value="activeDownload.percentage"
        :bg-color="activeDownload.error ? 'red': 'green'"
        :chunk-count="100"
        chunk-gap="5"
        :color="activeDownload.error ? 'red': 'green'"
        height="25"
        rounded="sm"
      >
        <small>{{ activeDownload.percentage.toFixed(2) }}%</small>
      </v-progress-linear>
      <small v-if="activeDownload.error" class="text-error">{{ activeDownload.error }}</small>
      <small v-if="activeDownload.isCancelled" class="text-warning">Cancelled</small>
    </v-list-item-subtitle>
    <template #append>
      <v-btn :icon="icon" variant="text" density="comfortable" @click="onClick" />
    </template>
  </v-list-item>
</template>

<script lang="ts" setup>
import { mdiCancel, mdiClose } from '@mdi/js'

const { activeDownload } = defineProps<{
  activeDownload: ActiveDownload
}>()
const emit = defineEmits<{
  clear: [value: string]
}>()
const canBeCleared = computed(() => activeDownload.error || activeDownload.isFinished || activeDownload.isCancelled)
const icon = computed(() => {
  if (canBeCleared.value) {
    return mdiClose
  }
  return mdiCancel
})
let timeoutId: unknown = undefined
watchEffect(() => {
  if (canBeCleared.value && !timeoutId) {
    timeoutId = setTimeout(() => {
      emit('clear', activeDownload.id)
    }, 60000)
  }
})

function onClick() {
  if (canBeCleared.value) {
    emit('clear', activeDownload.id)
  } else {
    activeDownload.controller.abort('User cancelled')
  }
}
</script>

<style lang="css">
</style>
